var _g, _path, _path2, _path3, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailExpiredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 79,
    viewBox: "0 0 99 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_15324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9827 23.8105H68.0173C72.2562 23.8105 76.3214 25.4752 79.3188 28.4384C82.3161 31.4016 84 35.4206 84 39.6112V68.1007H0V39.6112C0 35.4206 1.68389 31.4016 4.68122 28.4384C7.67856 25.4752 11.7438 23.8105 15.9827 23.8105V23.8105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9828 25.2918H68.0175C71.859 25.2918 75.5431 26.8005 78.2594 29.4859C80.9758 32.1713 82.5018 35.8134 82.5018 39.6112V66.6194H1.49854V39.6112C1.49854 35.8134 3.02456 32.1713 5.74089 29.4859C8.45723 26.8005 12.1414 25.2918 15.9828 25.2918V25.2918Z",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9827 23.8105H20.7675C25.0064 23.8105 29.0716 25.4752 32.069 28.4384C35.0663 31.4016 36.7502 35.4206 36.7502 39.6112V68.1007H0V39.6112C0 35.4206 1.68389 31.4016 4.68122 28.4384C7.67856 25.4752 11.7438 23.8105 15.9827 23.8105V23.8105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9828 25.2918H20.7677C24.6091 25.2918 28.2933 26.8005 31.0096 29.4859C33.726 32.1713 35.252 35.8134 35.252 39.6112V66.6194H1.49854V39.6112C1.49854 35.8134 3.02456 32.1713 5.74089 29.4859C8.45723 26.8005 12.1414 25.2918 15.9828 25.2918V25.2918Z",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1001 33.4686H57.7503",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8448 18.457L66.2372 10.9645L50.9248 3V33.9871",
    fill: "#ED8044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8448 18.457L66.2372 10.9645L50.9248 3V33.9871",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5146 66.731V77.0656H55.452V66.731",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3426 48.5573V43.353H9.66064V48.5573H27.8409",
    fill: "#FFE54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3426 48.5573V43.353H9.66064V48.5573H27.8409",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.165 75.9692C90.6843 75.9692 95.9692 70.6843 95.9692 64.165C95.9692 57.6457 90.6843 52.3608 84.165 52.3608C77.6457 52.3608 72.3608 57.6457 72.3608 64.165C72.3608 70.6843 77.6457 75.9692 84.165 75.9692Z",
    fill: "#ED8044"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.512 57.3776H86.0532L85.0414 66.8209H83.0179L82.512 57.3776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9356 69.7132C85.9356 70.6911 85.1429 71.4838 84.165 71.4838C83.1871 71.4838 82.3944 70.6911 82.3944 69.7132C82.3944 68.7353 83.1871 67.9426 84.165 67.9426C85.1429 67.9426 85.9356 68.7353 85.9356 69.7132Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.165,
    cy: 64.165,
    r: 12.665,
    stroke: "#1E1E1E",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_15324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailExpiredIcon);
export default __webpack_public_path__ + "static/media/EmailExpiredIcon.a17f3f85f12add5144e0102654e8ef9a.svg";
export { ForwardRef as ReactComponent };